import React from 'react';
import CopyableExpandableFormGroup from './CopyableExpandableFormGroup';

export default function ContractFormGroup({ value }) {
  return <CopyableExpandableFormGroup label="Contract Address" value={value} />;
}
